import "./DataCollection.css";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import TextInput from "./Inputs/TextInput";
import LabeledBooleanInput from "./Inputs/LabeledBooleanInput";
import DateInput from "./Inputs/DateInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import { useTranslation } from "react-i18next";
import DropdownInput from "./Inputs/DropdownInput";
import { GENDERS } from "../Utils/PlanUtils";
import BooleanInput from "./Inputs/BooleanInput";
import { useEffect, useState } from "react";
import NumberInput from "./Inputs/NumberInput";

const TransferDataCollection = ({ state }) => {
    const { t } = useTranslation();
    const transfer = state.transfer;
    const setTransfer = state.setTransfer;

    const transfers = [
        { code: "transferCode1", amount: "transferAmount1" },
        { code: "transferCode2", amount: "transferAmount2" },
        { code: "transferCode3", amount: "transferAmount3" }
    ];

    return (
        <form>
            <InputRowGroup label={t("Relinquishing Beneficiary")}>
                <InputRow label={t("Relinquishing and receiving beneficiary are the same person?")}>
                    <BooleanInput
                        label={t("Yes")}
                        name={"relinquishIsBeneficiary"}
                        state={transfer}
                        onChange={handleChange(setTransfer)}
                        BooleanInput />
                </InputRow>
            </InputRowGroup>

            {/*Relinquishing Promoter*/}
            <InputRowGroup label={t("Relinquishing Promoter")}>
                <InputRow label={t("Name")}>
                    <TextInput
                        name={"promoterName"}
                        state={transfer}
                        onChange={handleChange(setTransfer)}
                    />
                </InputRow>

                {/*Address*/}
                <InputRow label={t("Address")}>
                    <TextInput
                        name={"promoterAddress"}
                        state={transfer}
                        onChange={handleChange(setTransfer)}
                    />
                </InputRow>
            </InputRowGroup>

            {/* Transfer Details */}
            <InputRowGroup label={t("Transfer Details")}>
                {/*From RESP Contract Number*/}
                <InputRow label={t("From RESP Contract Number")}>
                    <TextInput
                        name={"promoterContractNumber"}
                        state={transfer}
                        onChange={handleChange(setTransfer)}
                    />
                </InputRow>

                {/* Transfer balance of account*/}
                <InputRow label={t("Transfer balance of account?")}>
                    <BooleanInput
                        label={t("Yes")}
                        name={"transferBalance"}
                        state={transfer}
                        onChange={handleChange(setTransfer)}
                    />

                    {/*only show when transferBalance is false*/}
                    {!transfer.transferBalance &&
                        <DropdownInput
                            name={"transferPercent"}
                            state={transfer}
                            onChange={handleChange(setTransfer)}
                            booleanValue={true}
                            options={
                                [
                                    { label: "$", value: false },
                                    { label: "%", value: true }
                                ]
                            } // TODO this doesn't work for some reason? The dropdown doesn't change the sign everywhere
                        />
                    }
                </InputRow>

                {/* Transfer Amount */}
                {!transfer.transferBalance &&
                    <>
                        <InputRow label={t("Transfer Amount")}>
                            {transfer.transferPercent ? "%" : "$"}
                            <NumberInput
                                name={"transferAmount"}
                                state={transfer}
                                onChange={handleChange(setTransfer)}
                            />
                        </InputRow>

                        {/* Transfer CLB Amount */}
                        <InputRow label={t("Transfer CLB Amount")}>
                            {transfer.transferPercent ? "%" : "$"}
                            <NumberInput
                                name={"transferClb"}
                                state={transfer}
                                onChange={handleChange(setTransfer)}
                            />
                        </InputRow>

                        {/* Transfer BCTESG Amount*/}
                        <InputRow label={t("Transfer BCTESG Amount")}>
                            {transfer.transferPercent ? "%" : "$"}
                            <NumberInput
                                name={"transferBc"}
                                state={transfer}
                                onChange={handleChange(setTransfer)}
                            />
                        </InputRow>
                    </>
                }
            </InputRowGroup>

            {!transfer.transferBalance &&
                // Redemption Instructions (Optional)
                <InputRowGroup label={t("Redemption Instructions (optional)")}>
                    <InputRow label={t("Investment Code/Name")}>
                        {t("Amount")}
                    </InputRow>

                    {transfers.map((transfer, index) => (
                        <InputRow key={index}>
                            <TextInput
                                name={transfer.code}
                                state={state.transfer}
                                onChange={handleChange(setTransfer)}
                            />

                            <NumberInput
                                name={transfer.amount}
                                state={state.transfer}
                                onChange={handleChange(setTransfer)}
                            />
                        </InputRow>
                    ))}

                </InputRowGroup>
            }
        </form>
    );
};

export default TransferDataCollection;
